import frappe from './frappe';
import { fetchStockWithLabels } from './getStocks';

export async function getFilteredVariants(parentCode) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Item?filters=[["variant_of","=","${parentCode}"]]&fields=["name","item_name","standard_rate","attributes"]&limit=50`
    );
    if (!data.data || data.data.length === 0) return null;

    const variants = await Promise.all(
      data.data.map(async (v) => {
        const { data: full } = await frappe.get(`/api/resource/Item/${v.name}`);
        const item = full.data;
        const attr = item.attributes?.[0];
        return {
          fk_product_child: item.name,
          variation_price: item.standard_rate,
          attribute_id: attr?.attribute || null,
          fk_prod_attr_val: attr?.attribute_value || null,
        };
      })
    );
    return variants;
  } catch (error) {
    console.error('Error fetching variants:', error.message);
    return null;
  }
}

// En Frappe los valores de atributo están en Item Attribute
export async function getAttributeValues(attributeName) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Item%20Attribute/${encodeURIComponent(attributeName)}`
    );
    return (data.data.item_attribute_values || []).map(v => ({
      id: v.name,
      value: v.attribute_value,
    }));
  } catch (error) {
    console.error('Error fetching attribute values:', error.message);
    return null;
  }
}

export async function getVariantsWithValues(parentCode) {
  try {
    const variants = await getFilteredVariants(parentCode);
    if (!variants || variants.length === 0) return false;

    const combined = await Promise.all(
      variants.map(async (variant) => {
        let stock = [];
        try {
          stock = (await fetchStockWithLabels(variant.fk_product_child)) || [];
        } catch (e) {
          console.error(`Error fetching stock for ${variant.fk_product_child}:`, e.message);
        }
        return {
          fk_product_child: variant.fk_product_child,
          variation_price: variant.variation_price,
          // En Frappe el valor del atributo viene directamente en fk_prod_attr_val
          value: variant.fk_prod_attr_val,
          stock,
        };
      })
    );
    return combined;
  } catch (error) {
    console.error('Error combining variant data:', error.message);
    return null;
  }
}
